<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      :quick-search-props="[
        { prop: 'name', label: '岗位名称' },
        { prop: 'p.CODE_', label: '岗位编码' },
        { prop: 'j.NAME_', label: '职务名称' }
      ]"
      :show-custom-column="false"
      :show-export="false"
      ref="ecoTable"
    >
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" @click="showDialog()" type="primary">添加</el-button>
          <fe-delete-button :url="demDeleteUrl" :htTable="$refs.ecoTable" parameter="postCodes" pk="code" class="marginRight16" @after-delete="afterDelete"
            >删除</fe-delete-button
          >
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="name" label="岗位名称" :sortable="true" :show-overflow-tooltip="true" width="200">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleCommand({ row: row, command: 'assignMenu' })" title="点击编辑">{{ row.name }}</el-link>
          </template>
        </eco-table-column>
        <eco-table-column prop="code" label="岗位编码" width="150" :show-overflow-tooltip="true" />
        <eco-table-column prop="jobName" label="职务名称" width="200" :show-overflow-tooltip="true" />
        <eco-table-column prop="pathName" label="组织路径" :show-overflow-tooltip="true" />
        <eco-table-column label="操作" width="150">
          <template v-slot="{ row }">
            <el-link type="primary" :underline="false" @click="handleCommand({ row: row, command: 'disPersonnel' })">分配人员</el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>

    <eco-sidebar-dialog
      destroy-on-close
      width="28%"
      :title="(diaType == 'add' ? '添加' : '编辑') + '岗位'"
      :visible="dialogVisible"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <el-form v-model="orgPost" style="padding: 20px">
        <eco-form-item label="职务名称" prop="jobCode" label-width="100px" v-if="diaType === 'add'">
          <eco-select v-model="orgPost.jobCode" class="m-r" :options="jobs" :props="{ key: 'groupCode', value: 'name' }" :validate="{ required: true }" />
        </eco-form-item>
        <eco-form-item label="岗位名称" prop="name" label-width="100px">
          <eco-input v-model="orgPost.name" autocomplete="off" :validate="{ required: true }" placeholder="请输入名称"></eco-input>
        </eco-form-item>
        <eco-form-item label="岗位编码" prop="code" label-width="100px">
          <eco-input
            v-model="orgPost.code"
            v-pinyin="orgPost.name"
            autocomplete="off"
            :validate="{ required: true, alpha_dash: true }"
            placeholder="请输入别名"
            :disabled="diaType != 'add'"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="岗位组织" label-width="100px" :validate="{ required: true }">
          <eco-input v-model="orgPost.orgName" readonly placeholder="选择岗位组织" v-if="orgPost.orgName" />
          <eco-input v-model="orgPost.orgName" readonly placeholder="选择岗位组织" :validate="{ required: true }" v-else />
          <el-button @click="selectOrg" type="primary" size="mini">选择岗位组织</el-button>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogCancle('dialogVisible')">{{ $t('eip.common.cancel') }}</el-button>
        <fe-submit-button
          :url="saveRoleUrl"
          :model="orgPost"
          :isSubmit="isSubmit"
          :requestMethod="requestMethod"
          scopeName="editDemForm"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>

    <eco-sidebar-dialog destroy-on-close width="40%" title="查看岗位详情" :visible="diaType === 'showInfo'" :before-close="handleClose" append-to-body>
      <div style="padding: 20px; height: calc(100% - 40px)">
        <table class="form-table" cellspacing="0" cellpadding="0" border="0">
          <tbody>
            <tr>
              <th width="150px">岗位名称（编码）:</th>
              <td>{{ orgPost.name }}({{ orgPost.id }})</td>
            </tr>
            <tr>
              <th width="150px">所属职务（编码）:</th>
              <td>{{ orgPost.jobName }}({{ orgPost.relDefId }})</td>
            </tr>
            <tr>
              <th width="150px">所属组织（编码）:</th>
              <td>{{ orgPost.orgName }}({{ orgPost.orgId }})</td>
            </tr>
            <tr>
              <th width="150px">岗位人员:</th>
              <td>
                <el-table :data="postUser" style="width: 100%" height="200" border="true">
                  <el-table-column prop="fullName" label="姓名" width="100" />
                  <el-table-column prop="pathName" label="人员所属组织全路径" />
                </el-table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </eco-sidebar-dialog>

    <fe-load-data :url="loadDataUrl" context="uc" @after-load-data="afterLoadData"></fe-load-data>

    <!-- 组织选择对话框  -->
    <eip-org-dialog ref="eipOrgDialog" @onConfirm="eipOrgDialogOk" single append-to-body />

    <distrubutive-user ref="distrubutiveUser"></distrubutive-user>
  </div>
</template>
<script>
import org from '@/api/org.js'
const eipOrgDialog = () => import('@/components/dialog/EipOrgDialog.vue')
import distrubutiveUser from './DistrubutiveUser'
export default {
  components: {
    eipOrgDialog,
    distrubutiveUser
  },
  computed: {
    demDeleteUrl: function () {
      return window.context.uc + '/api/org/v1/orgPost/deleteOrgPost'
    },
    saveRoleUrl: function () {
      let preUrl = window.context.uc + '/api/org/v1/orgPost'
      if (this.orgPost.id) {
        preUrl += '/updateOrgPost'
      } else {
        preUrl += '/saveOrgPost'
      }
      return preUrl
    },
    requestMethod: function () {
      return 'POST'
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisibleMenuPerm: false,
      orgPost: {
        name: '',
        code: '',
        jobCode: '',
        orgCode: ''
      },
      isSubmit: true,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      loadDataUrl: '',
      menuPerm: {},
      allowRoles: [],
      diaType: '',
      jobs: [],
      postUser: [],
      readOnly: true,
      tempOrgPost: {}
    }
  },
  mounted() {
    this.$validator = this.$root.$validator
  },
  methods: {
    selectOrg() {
      this.$refs['eipOrgDialog'].showDialog()
    },
    setDemDefault(row) {
      org.setDemDefault(row.code).then(() => {
        this.$refs.ecoTable.load()
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.diaType = 'close'
      this.loadDataUrl = ''
    },
    handleCloseMenuPerm() {
      this.dialogVisibleMenuPerm = false
    },
    showDialog(row) {
      let pageResult = {
        pageBean: {
          page: 1,
          pageSize: 500,
          total: 0
        }
      }
      org.getJobPage(pageResult).then((response) => {
        this.jobs = response.rows
      })
      this.dialogVisible = true
      if (row) {
        this.loadDataUrl = `/api/org/v1/orgPost/getOrgPost?postCode=${row.code}`
      } else {
        this.orgPost = { name: '', code: '' }
        this.diaType = 'add'
      }
      if (this.diaType === 'showInfo') {
        this.dialogVisible = false
      }
    },
    dialogCancle(dialogVisible) {
      this[dialogVisible] = false
    },
    loadData(param, cb) {
      org
        .getOrgPostPage(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      this.readOnly = false
      switch (params.command) {
        case 'showInfo':
          this.diaType = 'showInfo'
          // this.showDialog(params.row)
          this.orgPost = params.row
          org.getFullname(params.row.id).then((resp) => {
            this.postUser = resp
          })
          break
        case 'assignMenu':
          this.diaType = 'edit'
          this.showDialog(params.row)
          break
        case 'disPersonnel':
          this.$refs.distrubutiveUser.showDialog(params.row.id, params.row.code)
          break
        default:
          break
      }
    },
    async beforeSaveData() {
      this.isSubmit = true
    },
    afterSaveData() {
      this.dialogVisible = false
      this.$refs.ecoTable.load()
    },
    afterDelete() {
      this.$refs.ecoTable.load()
    },
    afterLoadData(data) {
      // 编辑角色
      if (this.dialogVisible || this.diaType === 'showInfo') {
        this.orgPost = data.value
        this.tempOrgPost = JSON.parse(JSON.stringify(this.orgPost))
        setTimeout(() => this.$validator.validateAll('editDemForm'))
      }
    },
    eipOrgDialogOk(data) {
      if (data.length > 1) {
        this.$message.error('岗位组织不能选择多个')
        return
      }
      if (this.tempOrgPost.orgId && this.tempOrgPost.orgId != data[0].id) {
        let this_ = this
        this.$confirm('修改所属组织，保存后当前岗位下的人员会一并转移到新组织下', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning',
          closeOnClickModal: false
        }).then(() => {
          this_.orgPost.orgCode = data[0].code
          this_.$set(this.orgPost, 'orgName', data[0].name)
        })
      } else {
        this.orgPost.orgCode = data[0].code
        this.$set(this.orgPost, 'orgName', data[0].name)
      }
    }
  }
}
</script>
<style scoped>
/* div[aria-invalid="true"] >>> .el-input__inner,
div[aria-invalid="true"] >>> .el-input__inner:focus {
  border-color: #f56c6c;
} */
</style>
